// Pure CREATE-statement skeletons for the "New view / event / function /
// procedure" flows (opened in a seeded query tab). Routines + events are
// DELIMITER-wrapped so they run as-is via the editor's "Run script". The object
// NAME is backtick-quoted; the modal validates it first.

function bq(name) { return '`' + String(name || '').replace(/`/g, '``') + '`'; }

export function viewSkeleton(name) {
  return `CREATE OR REPLACE VIEW ${bq(name)} AS
SELECT
    *
FROM
    -- table(s)
;
`;
}

export function eventSkeleton(name) {
  return `DELIMITER $$

CREATE EVENT ${bq(name)}
  ON SCHEDULE EVERY 1 DAY
  ON COMPLETION PRESERVE
  ENABLE
DO
BEGIN
  -- statements
END$$

DELIMITER ;
`;
}

// kind: 'function' | 'procedure'. params: [{ name, mode, type }] — for a FUNCTION
// the mode is dropped (MySQL function params are always IN). returns: the
// function's RETURNS type (ignored for a procedure).
export function routineSkeleton({ kind, name, params = [], returns = 'INT' }) {
  const isFn = kind === 'function';
  const ps = (params || []).filter((p) => p && (p.name || '').trim());
  const paramText = ps.length
    ? '\n  ' + ps.map((p) => {
        const mode = isFn ? '' : `${(p.mode || 'IN').toUpperCase()} `;
        return `${mode}${(p.name || '').trim()} ${(p.type || 'INT').trim()}`;
      }).join(',\n  ') + '\n'
    : '';
  if (isFn) {
    return `DELIMITER $$

CREATE FUNCTION ${bq(name)}(${paramText})
RETURNS ${(returns || 'INT').trim()}
DETERMINISTIC
BEGIN
  -- statements
  RETURN NULL;
END$$

DELIMITER ;
`;
  }
  return `DELIMITER $$

CREATE PROCEDURE ${bq(name)}(${paramText})
BEGIN
  -- statements
END$$

DELIMITER ;
`;
}

// Editor (DROP+CREATE, NO DELIMITER) skeleton — the shape the ScriptEditor saves
// via saveRoutine → ExecuteSPScript, which splits on the FIRST ';' (the DROP) and
// runs the remainder (CREATE … END) as one statement. This MUST match the shape
// loadRoutine returns for an existing routine, so the editor's Save works with no
// manual fixes. Same param formatting as routineSkeleton (IN/OUT/INOUT for
// procedures; bare `name type` for functions). NO trailing ';' after END.
export function routineEditorSkeleton({ kind, name, params = [], returns = 'INT' }) {
  const isFn = kind === 'function';
  const ps = (params || []).filter((p) => p && (p.name || '').trim());
  const paramText = ps.length
    ? '\n  ' + ps.map((p) => {
        const mode = isFn ? '' : `${(p.mode || 'IN').toUpperCase()} `;
        return `${mode}${(p.name || '').trim()} ${(p.type || 'INT').trim()}`;
      }).join(',\n  ') + '\n'
    : '';
  if (isFn) {
    return `DROP FUNCTION IF EXISTS ${bq(name)};
CREATE FUNCTION ${bq(name)}(${paramText})
RETURNS ${(returns || 'INT').trim()}
DETERMINISTIC
BEGIN
  -- statements
  RETURN NULL;
END`;
  }
  return `DROP PROCEDURE IF EXISTS ${bq(name)};
CREATE PROCEDURE ${bq(name)}(${paramText})
BEGIN
  -- statements
END`;
}
